import { EntityKeyByReference, Note } from '@card-software/library';
import { IncomingReceiptLineBase } from '../receipt-line-base';
import { AuditTrail } from '@card-software/nexus-models';
import { Translation } from '../translation';
import { StatusHistoryEntry } from './goods-receipt';

export enum InternalReturnStatus {
  Pending = 0,
  Processing = 1,
  Completed = 2,
  Cancelled = 3,
  Rejected = 4,
}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface InternalReturnLine extends IncomingReceiptLineBase {}

export interface InternalReturn extends AuditTrail {
  /** Descends from an Administrative purchase order (#5942); only role holders can see it, the API enforces. */
  isAdministrative?: boolean;
  id?: string;
  number?: string;
  initiator: EntityKeyByReference;
  status: InternalReturnStatus;
  locationCode: string;
  locationName?: Translation;
  departmentReference?: string;
  dispatchNumber?: string;
  returnDate: Date;
  entries: InternalReturnLine[];
  receiverUserName: string;
  notes?: Note[];
  statusHistory?: StatusHistoryEntry<InternalReturnStatus>[];
}
